
import { defineComponent } from "vue";
import CreateEditDialog from "@/components/controls/catalogueGrid/CreateEditDialog.vue";
import DxTextBox from "devextreme-vue/text-box";
import DxCheckBox from "devextreme-vue/check-box";
import DxTextArea from "devextreme-vue/text-area";
import mountComponentMixin from "@/mixins/MountComponentMixin";
import IntegerControl from "@/components/controls/base/IntegerControl.vue";
import DecimalControl from "@/components/controls/base/DecimalControl.vue";
import CatalogueSelectControl from "@/components/controls//base/CatalogueSelectControl.vue";
import { getContainer } from "../../../api/containerApi";

export default defineComponent({
  components: {
    CreateEditDialog,
    DxTextBox,
    DxCheckBox,
    DxTextArea,
    IntegerControl,
    DecimalControl,
    CatalogueSelectControl,
  },
  mixins: [mountComponentMixin],
  props: {
    saveModelCallback: { required: true },
  },
  data() {
    return {
      model: "",
    };
  },
  methods: {
    async onChange() {
      const { data }: { data: any } = await getContainer(
        this.model.containerId
      );
      this.setData(data);
    },
    setData(data: any) {
      delete data["id"];
      Object.assign(this.model, data);
    },
    dialog() {
      return this.$refs.dialog as any;
    },
    open(model: any, editType: any) {
      this.dialog().open(model, editType);
      this.model = this.dialog().createEditModel;
    },
    close() {
      this.dialog().close();
    },
    save() {
      this.dialog().save();
    },
  },
});
